var React = require('react');

function IcResultComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-result"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M3.3751 2.94336L4.5001 1.81836L5.6251 2.94336L6.7501 1.81836L7.8751 2.94336L9.0001 1.81836L10.1251 2.94336L11.2501 1.81836L12.3751 2.94336L13.5001 1.81836L14.6251 2.94336L15.5251 2.04336V15.957L14.6251 15.057L13.5001 16.182L12.3751 15.057L11.2501 16.182L10.1251 15.057L9.0001 16.182L7.8751 15.057L6.7501 16.182L5.6251 15.057L4.5001 16.182L3.3751 15.057L2.4751 15.957V2.04336L3.3751 2.94336ZM3.5251 3.45016V14.5502H14.4751V3.45016H3.5251ZM4.7251 12.5252V11.4752H13.2751V12.5252H4.7251ZM4.7251 9.52516V8.47516H13.2751V9.52516H4.7251ZM4.7251 6.52516V5.47516H13.2751V6.52516H4.7251Z","fill":"#3E3E3E"})));
}

IcResultComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcResultComponent;

IcResultComponent.default = IcResultComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/MyTarifSectionV2/images/ic-result.component.svg
// module id = 1641
// module chunks = 0